// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AgRK5tkfjtpQDp {\n  padding: 4px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid rgba(9, 30, 66, 0.13);\n}\n._14vsXHNbqrA7Am p,\n._14vsXHNbqrA7Am h3 {\n  margin: 0 0 8px;\n}\n._12hREez0NE7GgG,\n._12hREez0NE7GgG a {\n  color: #5e6c84;\n}\n._12hREez0NE7GgG a:not(.A8qaN1S5Y72wzS):hover {\n  color: #172b4d;\n}\n._2ylm63rTCFcF4P {\n  background-color: #e9e9e9;\n}\n._2xAUNkao-nYmao {\n  text-decoration: none;\n}\n._2xAUNkao-nYmao:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"announcement": "AgRK5tkfjtpQDp",
	"announcement-blog": "_14vsXHNbqrA7Am",
	"quiet": "_12hREez0NE7GgG",
	"disabled": "A8qaN1S5Y72wzS",
	"announcement-downtime": "_2ylm63rTCFcF4P",
	"announcementHeaderLink": "_2xAUNkao-nYmao"
};
export default ___CSS_LOADER_EXPORT___;
